module.exports = {
    btn_track:"Track",
    TrackingNumber:"Track Number",
    OrderCode:"Order Code",
    NewestTrack:"Newest Track",
    Status:"Status",
    All:"All",
    NotFound:"Not Found",
    Receivedin:"Received in",
    InTransit:"In Transit",
    PickUp:"Pick Up",
    Delivered:"Delivered",
    Undelivered:"Undelivered",
    Alert:"Alert",
    Returned:" Returned",
    QfishOrderTracking:"Qfish Order Tracking",
    Channel:"Channel",
    PleaseEnterNumbers:"Please enter numbers" ,
    Max_Query_Count_Tips:"Maximum query for 80 orders",
    Footer_Copyright_Countent:"QuickFish. All rights Reserved"
  };